import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'popup-banner-type-2';

/**
 * Compact horizontal banner strip with action buttons and configurable alignment.
 * Displays text content via prop with action buttons in a minimal-padding section.
 * Used for promotional announcements or alerts at the top or bottom of a page.
 *
 * @category Popups
 * @slot actions - Container for action buttons (1-5 buttons, <me-button variant='tertiary' size='sm'>)
 * @example
 *   <popup-banner-type-2 text="Limited time offer: Get 30% off all plans!">
 *     <me-button slot="actions" variant="tertiary" size="sm">Claim Offer</me-button>
 *   </popup-banner-type-2>
 */

@Component({
  tag: 'popup-banner-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class PopupBannerType2 {
  /**
   * Horizontal content alignment inside the banner: 'left', 'center', or 'right'
   * @default 'end'
   */
  @Prop() align: 'start' | 'center' | 'end' = 'end';

  render() {
    // Rendered with plain elements rather than me-section/me-row/me-column: every gap
    // this block asked for was `none`, so the grid machinery contributed nothing, while
    // the dependency pulled all 33 KB of the layout class matrix into critical CSS —
    // this component is above the fold on most landings. See index.scss for the mapping.
    return (
      <section class={`${COMPONENT_NAME} ${COMPONENT_NAME}--align-${this.align}`}>
        <div class={`${COMPONENT_NAME}__container`}>
          <div class={`${COMPONENT_NAME}__row`}>
            <div class={`${COMPONENT_NAME}__actions`}>
              <slot name="actions"></slot>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
